var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('Heatmap',{attrs:{"templateID":_vm.$route.query.templateID,"userID":_vm.$route.query.userID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }